<template>
    <div class="login">
        <div class="img">
            <img src="../assets/login-bg.png" alt />
        </div>
        <div class="login-container">
            <el-form ref="ruleForm" status-icon :model="ruleForm" label-width="0px" :rules="rules">
                <el-form-item label prop="loginUserName">
                    <el-input v-model="ruleForm.loginUserName" placeholder="请输入email/手机号码"></el-input>
                </el-form-item>
                <el-form-item label prop="password">
                    <el-input v-model="ruleForm.password" type="password" placeholder="请输入密码"></el-input>
                </el-form-item>
            </el-form>
            <button style="cursor: pointer" @click="onSubmitValidate()">登录</button>
        </div>
    </div>
</template>

<script>
import * as apis from '../fetch/login';

import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'login',
    data() {
        return {
            ruleForm: {
                loginUserName: '',
                password: '',
            },
            rules: {
                loginUserName: [
                    { required: true, message: '请输入email/手机号码', trigger: 'blur' },
                ],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
            },
        };
    },
    methods: {
        ...mapActions(['setreloadUserState']),
        onSubmitValidate() {
            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    this.onSubmit();
                } else {
                    return false;
                }
            });
        },
        onSubmit() {
            const params = { ...this.ruleForm };
            apis.login(params).then(res => {
                this.$router.push({ path: '/' });
                this.setreloadUserState(true);
            });
        },
    },
};
</script>

<style lang="less" scoped>
.login {
    width: 1200px;
    height: 618px;
    background-color: #ffffff;
    box-shadow: 0px 0px 30px 0px rgba(169, 169, 169, 0.5);
    border-radius: 40px;
    margin: 60px auto;
    display: flex;
    justify-content: space-between;
    padding: 60px 45px;
    .img {
        width: 480px;
        height: 395px;
        img {
            width: 100%;
        }
    }
    .login-container {
        padding-top: 100px;
        width: 458px;
        /deep/.el-form-item {
            border-bottom: 1px solid #cccdd0;
            padding: 10px 0;
            .el-input {
                font-size: 16px;
            }
            .el-input__inner {
                border: 0;
            }
            .el-form-item__error {
                margin-top: 14px;
                font-size: 14px;
                margin-left: 16px;
            }
        }
        button {
            width: 200px;
            height: 50px;
            line-height: 50px;
            background-color: #3c9539;
            border-radius: 39.5px;
            color: #fff;
            font-size: 18px;
            margin: 100px auto;
            display: block;
            border: none;
            outline: none;
        }
    }
}
</style>